import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import user from '../Auth/user';
import compose from '../compose';
import DateFilter from './DateFilter';
import AssChart from './AssChart';
import {CumulativeSumBy, SumUniqueBy, AvgByUnique} from './Functions';

class CustomersTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previousFilter: null,
      currentFilter: null,
      filters: [],
      inventoryChanges: null,
      standsProducts: [],
      data: [],
      filteredData: null
    };
  }

  fetchSales = (startDate, endDate) => {

    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;
    firebase.database()
      .ref(`shopkeepers/${shopkeeperId}/sales`)
      .orderByChild('paidAt')
      .startAt(startDate.getTime())
      .endAt(endDate.getTime())
      .once('value', (snapshot) => {
        const allSales = [];
        snapshot.forEach((data) => {
          const sale = {
            key: data.key,
            ...data.val()
          };
          allSales.push(this.enhanceSale(sale));
        });

        const sales = allSales.filter((sale) => (sale.standName));
        this.setState({allSales: sales, filteredData: sales});
      });
  }

  enhanceSale = (sale) => {
    const paidAt = new Date(sale.paidAt);
    sale.hour = '' + paidAt.getHours();
    sale.paidAtDate = paidAt;
    sale.paidAtDate.setHours(0,0,0,0);

    sale.count = 1;
    sale.registerPaymentCount = sale.isRegistrationPayment ? 1 : 0;
    sale.weekday = sale.paidAtDate.toLocaleString(this.props.user.language, {weekday: 'long'});
    sale.dayOfWeek = +sale.paidAtDate.getDay();
    sale.paidAtDateFormated = sale.paidAtDate.toLocaleDateString(this.props.user.language);
    sale.standName = sale.standId in this.props.stands ?
      this.props.stands[sale.standId].name : '';
    return sale;
  }

  onNewFilter = (key, value) => {
    const filters = this.state.filters;
    filters[key] = value;
    this.setState({filters});
  }

  cancelFilter = (key) => {
    const filters = this.state.filters;
    delete filters[key];
    this.setState({filters});
  }

  onFilterChange = (filter) => {
    const filteredData = this.state.data.filter(filter);
    this.setState({filteredData});
  }

  onEnlargeToggled = () => {
    // Forces redraw but flashes the screen
    this.setState({display: 'none'});
    setTimeout(() => this.setState({display: 'block'}), 1);
  }

  render() {

    const boxProps = {
      style: this.props.boxStyle,
      data: this.state.filteredData,
      filters: this.state.filters,
      cancelFilter: this.cancelFilter,
      onNewFilter: this.onNewFilter,
      onEnlargeToggled: this.onEnlargeToggled
    };

    const {t} = this.props;

    return (
      <div>
        <DateFilter updateFunction={this.fetchSales} />
        <div style={{clear: 'both'}}></div>
        <div style={{
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'space-between',
        }}>
          <AssChart {...boxProps}
            chartType='LineChart'
            title={t('dashboard.customer.cumuSumNewCards')}
            aggregate={new CumulativeSumBy('paidAtDateFormated', 'registerPaymentCount', t('amount'))} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            title={t('dashboard.customer.unique')}
            aggregate={new SumUniqueBy('paidAtDateFormated', 'userId', 'count', t('amount'))} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            title={t('dashboard.customer.avgPurchasesCustomerDate')}
            aggregate={new AvgByUnique('paidAtDateFormated', 'userId', 'count', t('amount'))} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            title={t('dashboard.customer.avgSumPurchasesCustomerDate')}
            aggregate={new AvgByUnique('paidAtDateFormated', 'userId', 'price', t('price'))} />
        </div>
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(CustomersTab);



// WEBPACK FOOTER //
// ./src/Dashboard/CustomersTab.js